import React from 'react';
import { Box } from '@mantine/core';
import { useState } from 'react';
import { Message } from './Message';
import type { SlackMessage } from '../../../api/slackConversation';

const THREAD_BORDER_COLOR = '#E1E4E8';

interface ThreadRepliesProps {
  replies: SlackMessage[];
  excerptRefIndexByMessageTs?: Map<string, number>;
  excerptRefsArray?: React.MutableRefObject<(HTMLDivElement | null)[]>;
  excerptTextsByMessageTs?: Map<string, string[]>;
}

export function ThreadReplies({
  replies,
  excerptRefIndexByMessageTs,
  excerptRefsArray,
  excerptTextsByMessageTs,
}: ThreadRepliesProps) {
  const [isOpen] = useState(true);

  if (!replies?.length) return null;

  return (
    <Box
      mt="xs"
      ml={40}
      pl="sm"
      style={{
        borderLeft: `2px solid ${THREAD_BORDER_COLOR}`,
        display: isOpen ? 'block' : 'none',
      }}
    >
      {replies
        .slice()
        .sort((a, b) => (a.ts < b.ts ? -1 : 1))
        .map((reply) => {
          const refIndex = excerptRefIndexByMessageTs?.get(reply.ts);
          const excerptRef =
            refIndex !== undefined && excerptRefsArray
              ? (el: HTMLDivElement | null) => {
                excerptRefsArray.current[refIndex] = el;
              }
              : undefined;
          return (
            <Message
              key={reply.ts}
              message={reply}
              isReply
              excerptRef={excerptRef}
              excerptTexts={excerptTextsByMessageTs?.get(reply.ts)}
            />
          );
        })}
    </Box>
  );
}
